import { useState } from "react";
import { toast } from "react-toastify";
import { Badge } from "src/components/ui/Badge";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/components/ui/Popover";
import { updateNewHireStatus } from "src/redux/api/_hr.api";
import { HiresType } from "src/redux/types/hires";

interface OnboardingTableProps {
  hires: HiresType[];
  refetch: () => void;
}

const OnboardingTable = ({ hires, refetch }: OnboardingTableProps) => {


  const [loading, setLoading] = useState(false);

  const handleUpdate = async (
    field: "status" | "employment_type",
    value: string,
    id: string,
  ) => {
    try {
      setLoading(true);
      const response = await updateNewHireStatus(id, { [field]: value });

      if(response.message.toLowerCase() === "success") {
        toast.success("Status Changed");
        refetch();
      }

    } catch (error) {
      toast.error("Failed to Update Status");
      console.error("Failed to update new hire:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <table className="w-full text-left border-collapse">
      <thead className="bg-gray-50">
        <tr className="text-sm text-gray-600 font-medium">
          <th className="py-3 px-2">Name</th>
          <th className="py-3 px-2">Position</th>
          <th className="py-3 px-2">Contact</th>
          <th className="py-3 px-2">Address</th>
          <th className="py-3 px-2">Hiring Type</th>
          <th className="py-3 px-2">Letter Type</th>
          <th className="py-3 px-2">Status</th>
        </tr>
      </thead>
      <tbody>
        {hires.map((item, idx) => (
          <tr
            key={idx}
            className="border-t border-gray-100 hover:bg-gray-50 transition text-gray-800 text-sm"
          >
            <td className="py-2 px-2">
              <div className="flex flex-col">
              <p className="font-semibold">{item.full_name}</p>
                {item.email}
              </div>
              </td>
            <td className="py-2 px-2">{item.position}</td>
            <td className="py-2 px-2">{item.contact_number}</td>
            <td className="py-2 px-2">{item.address}</td>
            <td className="py-2 px-2">{item.employment_type}</td>
            <td className="py-2 px-2">{item.letter_type}</td>

            {/* Status */}
            <td className="py-2 px-4">
              {item.status === "ACCEPTED" || item.status === "REJECTED" ? (
                <Badge
                  className={`px-3 py-1 rounded-full ${
                    item.status === "ACCEPTED"
                      ? "bg-green-100 text-green-700 border border-green-300"
                      : "bg-red-100 text-red-700 border border-red-300"
                  }`}
                >
                  {item.status}
                </Badge>
              ) : (
                <Popover>
                  <PopoverTrigger asChild>
                    <button
                      disabled={loading}
                      className={`px-3 py-1 border rounded-lg text-sm font-medium shadow-sm transition-colors duration-200 ${
                        item.status === "PENDING"
                          ? "bg-amber-100 text-amber-700 border-amber-300 hover:bg-amber-200"
                          : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
                      }`}
                    >
                      {loading ? "Updating..." : item.status}
                    </button>
                  </PopoverTrigger>
                  <PopoverContent className="p-2 w-48 space-y-1">
                    <button
                      onClick={() =>
                        handleUpdate("status", "ACCEPTED", item.id)
                      }
                      className="block w-full text-center px-3 py-2 text-sm rounded-lg bg-green-50 text-green-700 hover:bg-green-100 hover:text-green-800 transition-colors duration-200"
                    >
                      ACCEPTED
                    </button>
                    <button
                      onClick={() =>
                        handleUpdate("status", "REJECTED", item.id)
                      }
                      className="block w-full text-center px-3 py-2 text-sm rounded-lg bg-red-50 text-red-700 hover:bg-red-100 hover:text-red-800 transition-colors duration-200"
                    >
                      REJECTED
                    </button>
                  </PopoverContent>
                </Popover>
              )}
            </td>

            {/* Position Status */}
            {/* <td className="py-2 px-4">
              <Popover>
                <PopoverTrigger asChild>
                  <button
                    disabled={loading}
                    className={`px-3 py-1 border rounded-lg text-sm shadow-sm transition-colors duration-200 ${
                      item.employment_type === "CONFIRMED"
                        ? "bg-green-100 text-green-700 border-green-300 hover:bg-green-200"
                        : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
                    }`}
                  >
                    {loading
                      ? "Updating..."
                      : item.employment_type || "Set Type"}
                  </button>
                </PopoverTrigger>
                <PopoverContent className="p-2 w-60 space-y-1">
                  {positionStatusOptions.map((option) => (
                    <button
                      key={option}
                      onClick={() =>
                        handleUpdate("employment_type", option, item.id)
                      }
                      className={`block w-full text-center px-3 py-2 text-sm rounded-lg transition-colors duration-200 ${
                        option === "CONFIRMED"
                          ? "bg-green-50 text-green-700 hover:bg-green-100 hover:text-green-800"
                          : "bg-gray-50 text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      }`}
                    >
                      {option}
                    </button>
                  ))}
                </PopoverContent>
              </Popover>
            </td> */}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default OnboardingTable;
